import * as XLSX from 'xlsx';

export function removeBlankStringCells(worksheet: XLSX.WorkSheet): void {
  Object.keys(worksheet).forEach((cellRef) => {
    if (cellRef.startsWith('!')) {
      return;
    }

    const cell = worksheet[cellRef];
    if (cell && cell.v === '') {
      delete worksheet[cellRef];
    }
  });
}
